import dynamic from 'next/dynamic';
const Pagination = dynamic(() => import('./Caption'));
export default Pagination;
